export const SCREENTABS_VALIDATION_ERROR = 'SCREENTABS_VALIDATION_FAILED';
export const FIELD_VALIDATION_ERROR = 'FIELD_VALIDATION_FAILED';
export const MULTI_APP_CONFLICT_ERROR = 'MULTI_APP_CONFLICT_ERROR';
export const MULTI_APP_CONFLICT_CAUSE_FIELD = 'CONFLICT_CAUSE_FIELD';
export const MULTI_APP_CONFLICT_CAUSE_SCREENTABS = 'CONFLICT_CAUSE_SCREENTABS';
export const MULTI_APP_CONFLICT_CAUSE_OTHER_APPS = 'CONFLICT_CAUSE_OTHER_APPS';
